import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedTabState: "",
  selectedTabprojectrequest: null,
  selectedTabprojectapproved: null,
  selectedTabprojectassign: null,
  selectedTabprojectongoing: null,
  selectedTabprojectcomplete: null,

  filterRequestProjectsState: [],
  approvedOpProjectsState: [],
  assignedOpProjectsState: [],
  ongoingOpProjectsState: [],
  completeOpProjectsState: [],
  mytrainingOMProjectRequestState: [],
  mytrainingOMProjectAssignedState: [],
  mytrainingOMMyManagement : ""
};

const operationStateSlice = createSlice({
  name: "operationState",
  initialState,
  reducers: {
    setSelectedTabState: (state, action) => {
      state.selectedTabState = action.payload;
    },
    setSelectedTabProjectRequest: (state, action) => {
      state.selectedTabprojectrequest = action.payload;
    },
    setSelectedTabProjectApproved: (state, action) => {
      state.selectedTabprojectapproved = action.payload;
    },
    setSelectedTabProjectAssign: (state, action) => {
      state.selectedTabprojectassign = action.payload;
    },
    setSelectedTabProjectOngoing: (state, action) => {
      state.selectedTabprojectongoing = action.payload;
    },
    setSelectedTabProjectComplete: (state, action) => {
      state.selectedTabprojectcomplete = action.payload;
    },

    setFilterRequestProjectsState: (state, action) => {
      state.filterRequestProjectsState = action.payload;
    },
     setApprovedOpProjectsState: (state, action) => {
      state.approvedOpProjectsState = action.payload;
    },
    setAssignedOpProjectsState: (state, action) => {
      state.assignedOpProjectsState = action.payload;
    },
    setOngoingOpProjectsState: (state, action) => {
      state.ongoingOpProjectsState = action.payload;
    },
    setCompleteOpProjectsState: (state, action) => {
      state.completeOpProjectsState = action.payload;
    },
    setmytrainingOMProjectRequestState: (state, action) => {
      state.mytrainingOMProjectRequestState = action.payload;
    },
    setmytrainingOMProjectAssignedState: (state, action) => {
      state.mytrainingOMProjectAssignedState = action.payload;
    },
    setmytrainingOMMyManagement: (state, action) => {
      state.mytrainingOMMyManagement = action.payload;
    },
    // Optional: reset all (e.g. on logout or mount) – close all My Request tabs
    resetOperationState: (state) => {
      state.selectedTabState = "";
      state.selectedTabprojectrequest = false;
      state.selectedTabprojectapproved = false;
      state.selectedTabprojectassign = false;
      state.selectedTabprojectongoing = false;
      state.selectedTabprojectcomplete = false;
      state.filterRequestProjectsState = [];
      state.approvedOpProjectsState = [];
      state.assignedOpProjectsState = [];
      state.ongoingOpProjectsState = [];
      state.completeOpProjectsState = [];
      state.mytrainingOMProjectRequestState = [];
      state.mytrainingOMProjectAssignedState = [];
      state.mytrainingOMMyManagement = "";
    },
  },
});

export const {
  setSelectedTabState,
  setFilterRequestProjectsState,
  setApprovedOpProjectsState,
  setAssignedOpProjectsState,
  setOngoingOpProjectsState,
  setCompleteOpProjectsState,
  setmytrainingOMProjectRequestState,
  setmytrainingOMProjectAssignedState,
  resetOperationState,
  setmytrainingOMMyManagement,
  setSelectedTabProjectRequest,
  setSelectedTabProjectApproved,
  setSelectedTabProjectAssign,
  setSelectedTabProjectOngoing,
  setSelectedTabProjectComplete,
} = operationStateSlice.actions;

export default operationStateSlice.reducer;
